export const companyInfoInitialState = {
  name: "",
  email: "",
  portalName: "",
  industry: "",
  phoneNumber: "",
};
